export const getVariantNumberLetter = (variantNumber: number) =>
  String.fromCharCode(65 + variantNumber - 1);

export function getVariantMessage(
  isMaxVariantsCountReached: boolean,
  isDisabled: boolean,
  isDemoAccount: boolean,
  variantNumber: number,
) {
  if (isMaxVariantsCountReached) {
    return 'You have reached the maximum number of variants allowed';
  }
  if (isDisabled && !isDemoAccount) {
    return 'Your monthly quota is over';
  }
  return `Generate AI optimized email using variant ${getVariantNumberLetter(
    variantNumber,
  )}`;
}
